import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const getMailTemplates = (administracionId, barrioId) =>
  axios.get(`${HOST_API}api/mailTemplate/GetMailTemplates`, {
    params: { administracionId, barrioId },
  });

export const saveMailTemplate = (payload) =>
  axios.post(`${HOST_API}api/mailTemplate/SaveMailTemplate`, payload);

export const enviarConTemplate = (payload) =>
  axios.post(`${HOST_API}api/mailTemplate/EnviarConTemplate`, payload);
